import { render, staticRenderFns } from "./featured-products-slider.vue?vue&type=template&id=0adde212&"
import script from "./featured-products-slider.vue?vue&type=script&lang=js&"
export * from "./featured-products-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0adde212')) {
      api.createRecord('0adde212', component.options)
    } else {
      api.reload('0adde212', component.options)
    }
    module.hot.accept("./featured-products-slider.vue?vue&type=template&id=0adde212&", function () {
      api.rerender('0adde212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/featured-products-slider.vue"
export default component.exports